<template>
  <div class="top">
    <div class="topmain flex">
      <p>
        全国服务热线 <span style="color:#C10B17 ;font-weight: bold;font-size: 14px;margin-left: 5px;"> 0371-88176175 /
          15138687288</span>
      </p>
      <p class="flex" style="margin-left: 100px;">
      <div class="zhong">
        <el-popover placement="right" trigger="hover">
          <img src="../assets/xcx.jpg" alt="">
          <span slot="reference">小程序</span>
        </el-popover>
        <span>|</span>
        <span>微信公众号</span>
        <span>|</span>
        <el-popover placement="right" trigger="hover">
          <img src="../assets/app.png" alt="">
          <span slot="reference">下载App</span>
        </el-popover>
        <span>|</span>
        <span>常见问题解决</span>
      </div>
      </p>
      <div class="flex" v-if="userInfo!=null">
        <router-link :to="{path:'/personalCenter'}">
          <div>
            <img class="avatar_img" :src="'https://yunzhixuanpro.fw366.cn/'+userInfo.avatar_img" alt="">
            {{tel}}
          </div>
        </router-link>
        <div class="vip flex" @click="open">
          <img src="../assets/index/vip.png">
          <span>{{$store.state.isvip}}</span>
          <div class="light">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tel: '',
        userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
      }
    },
    created() {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      this.tel = JSON.parse(localStorage.getItem('userInfo')).mobile.replace(reg, "$1****$2");
    },
    methods: {
      open() {
        this.$http.getUserInfo().then(res => {
          if (res.data.bind_card > 0) {
            this.$message.success('您已开通VIP！无需重复开通')
            return
          } else {
            this.$store.commit('openVip', true);
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .avatar_img {
    vertical-align: middle;
    width: 30px;
    height: 30px;
  }

  .vip {
    padding: 0 15px;
    cursor: pointer;
    height: 42px;
    margin-left: 14px;
    position: relative;
    overflow: hidden;
    color: #FFFFFF;
    background: url(../assets/index/bg.png) no-repeat;
    width: 111px;
    height: 26px;
    background: #C10B17;
    border-radius: 4px;
    line-height: 26px;
    font-size: 12px;

    img {
      margin-left: 10px;
      vertical-align: middle;
      border-radius: 5px;
    }

    .light {
      content: '';
      display: block;
      position: absolute;
      left: -100%;
      width: 100px;
      height: 20px;
      transform: rotate(-65deg);
      background: rgba(255, 255, 255, .5);
      animation: cross 1.5s linear infinite
    }

    @keyframes cross {
      from {}

      to {
        left: 100%;
        transform: rotate(-65deg);
      }
    }

    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // color: #333333;
    }
  }

  .top {
    width: 100%;
    color: #666666;
    font-size: 12px;
    height: 47px;
    background: #F2F2F2;
    line-height: 47px;

    .zhong span {
      margin-right: 10px;
      cursor: pointer;
    }

    .topmain {
      width: 1280px;
      margin: 0 auto;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top.vue